import React from 'react';
import { ListItemIcon, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import Menu from '../../Menu';
import MenuItem from '../../Menu/MenuItem';
import AZSortingIcon from '../../../../assets/v2/AZSortingIcon';
import SortAscendingIcon from '../../../../assets/v2/SortAscendingIcon';
import SortDescendingIcon from '../../../../assets/v2/SortDescendingIcon';
import ZASortingIcon from '../../../../assets/v2/ZASortingIcon';

export const SORTING_TYPES = {
  ALPHABETICALLY: 'alphabetically',
  SIMPLE: 'simple',
};

const ColumnSort = ({
  handleClose,
  setSortBy,
  menuAnchor,
  isMenuOpen,
  column,
  type,
}) => {
  const handleOnSort = (direction) => {
    setSortBy([
      { id: column.Sort.key || column.id, order: direction ? 1 : -1 },
    ]);
    handleClose();
  };

  return (
    <>
      <Menu
        anchorEl={menuAnchor}
        open={isMenuOpen}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
      >
        {type === SORTING_TYPES.SIMPLE && [
          <MenuItem onClick={() => handleOnSort(1)} key="sort-asc">
            <ListItemIcon>
              <SortAscendingIcon />
            </ListItemIcon>
            <ListItemText>Sort Ascending</ListItemText>
          </MenuItem>,
          <MenuItem onClick={() => handleOnSort(0)} key="sort-desc">
            <ListItemIcon>
              <SortDescendingIcon />
            </ListItemIcon>
            <ListItemText>Sort Descending</ListItemText>
          </MenuItem>,
        ]}

        {type === SORTING_TYPES.ALPHABETICALLY && [
          <MenuItem onClick={() => handleOnSort(1)} key="sort-az">
            <ListItemIcon>
              <AZSortingIcon />
            </ListItemIcon>
            <ListItemText>Sort A to Z</ListItemText>
          </MenuItem>,
          <MenuItem onClick={() => handleOnSort(0)} key="sort-za">
            <ListItemIcon>
              <ZASortingIcon />
            </ListItemIcon>
            <ListItemText>Sort Z to A</ListItemText>
          </MenuItem>,
        ]}
      </Menu>
    </>
  );
};

ColumnSort.propTypes = {
  handleClose: PropTypes.func,
  setSortBy: PropTypes.func,
  menuAnchor: PropTypes.object,
  isMenuOpen: PropTypes.bool,
  column: PropTypes.object,
  type: PropTypes.oneOf(Object.values(SORTING_TYPES)),
};

export default ColumnSort;
